import Parse from "parse/dist/parse.min.js";
import { handleParseError } from "../../lib/Errors";
import { APP_SHOW_MODULE_ANWESENHEIT } from "@/lib/config/AppConfigurations";

let localSubscription = undefined;

function createSubscription(store) {
	if (APP_SHOW_MODULE_ANWESENHEIT == "true") {
		let absenceQuery = new Parse.Query("Absence");
		absenceQuery
			.notEqualTo("deleted", true)
			.find()
			.then((results) => {
				store.dispatch("absence/set", results);
			})
			.catch((error) => {
				handleParseError(error);
				console.log(error);
			});
		absenceQuery.subscribe().then((subscription) => {
			localSubscription = subscription;

			subscription.on("create", (object) => {
				store.dispatch("absence/insert", object);
			});
			subscription.on("update", (object) => {
				store.dispatch("absence/replace", object);
			});
			subscription.on("enter", (object) => {
				store.dispatch("absence/insert", object);
			});
			subscription.on("leave", (object) => {
				store.dispatch("absence/delete", object);
			});
			subscription.on("delete", (object) => {
				store.dispatch("absence/delete", object);
			});
			subscription.on("close", () => {});
			subscription.on("error", (error) => {
				console.log("Absence subscription error", error);
			});
		});
	}
}

export default function createAbsenceSubscription() {
	return (store) => {
		if (store.state.currentUser) {
			createSubscription(store);
		}
		store.subscribe((mutation) => {
			if (mutation.type === "SET_CURRENT_USER") {
				if (localSubscription) {
					localSubscription.unsubscribe();
				}
				if (store.state.currentUser) {
					createSubscription(store);
				}
			}
		});
	};
}
